export default __webpack_public_path__ + "static/media/feedbacks.20063429.svg";